import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';
import { Alert, Checkbox, FormControlLabel, Stack } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';

interface AddDashboardFiltersToAnalysisCheckboxProps {
  checked: boolean;
  onChange: (shouldSaveDashboardFilters: boolean) => void;
  useCase: AnalysisUseCase;
}

export const AddDashboardFiltersToAnalysisCheckbox = ({
  checked,
  onChange,
  useCase,
}: AddDashboardFiltersToAnalysisCheckboxProps) => {
  const analysisType = getAnalysisTypeDisplayName(useCase);

  return (
    <Stack spacing={1}>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={`Save Dashboard Filters with ${analysisType}`}
      />
      {checked && (
        <Alert
          severity="info"
          sx={{
            border: '1px solid',
            borderColor: 'info.main',
          }}
        >
          Dashboard filters will be saved as a part of this {analysisType}.
        </Alert>
      )}
    </Stack>
  );
};
